import React, { useState } from 'react';
import styled from 'styled-components';
import BaseButton from './BaseButton';
import tickIcon from '../../../../static/img/carretCircleIcon.svg';

import { Colors } from '../../../../scss/common/style';

interface Props {
  size?: 'sm' | 'lg';
  onClick?: () => void;
  title?: string;
  isSubmitting?: boolean;
  active?: boolean;
  disabled?: boolean;
  IsPalletBreakdownVisible?: boolean;
}

export default function DropdownButton({
  onClick,
  title,
  isSubmitting = false,
  active = false,
  disabled = false,
  IsPalletBreakdownVisible,
}: Props): JSX.Element {
  return (
    <StyledButton>
      <BaseButton
        title={title}
        onClick={onClick}
        isSubmitting={isSubmitting}
        disabled={disabled}
        active={active}
        icon={tickIcon}
        rotateIcon={IsPalletBreakdownVisible}
        reverse={true}
        iconSize="35px"
      />
    </StyledButton>
  );
}

const StyledButton = styled.div`
  z-index: 2;
  button {
    display: flex;
    flex-direction: row;
    align-items: center;
    background-color: #fbfbfb;
    border: 1px solid #eeeeee;
    padding: 9px;
    color: ${Colors.darkBrown};
    &:hover {
      color: ${Colors.darkRed};
      background-color: #eeeeee;
    }
    &:active {
      color: #fff;
      background-color: ${Colors.darkBrown};
      border-color: ${Colors.darkBrown};
    }
  }
`;
